import styled from 'styled-components';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('button')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalCloseButton.tsx